import { render } from "./AdfoundNotificationManagementSettings.vue?vue&type=template&id=5ed2bf06"
import script from "./AdfoundNotificationManagementSettings.vue?vue&type=script&lang=js"
export * from "./AdfoundNotificationManagementSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__